import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <circle cx="9" cy="9.5" r="9" fill="#C52737" />
    <mask id="path-2-inside-1_26269_46919" fill="white">
      <path d="M8.25 12.7368H9.82895V14.3158H8.25V12.7368Z" />
      <path d="M8.25 5H9.82895V11.1579H8.25V5Z" />
    </mask>
    <path d="M8.25 12.7368H9.82895V14.3158H8.25V12.7368Z" fill="white" />
    <path d="M8.25 5H9.82895V11.1579H8.25V5Z" fill="white" />
    <path
      d="M9.82895 12.7368H13.8289V8.73684H9.82895V12.7368ZM8.25 12.7368V8.73684H4.25V12.7368H8.25ZM8.25 14.3158H4.25V18.3158H8.25V14.3158ZM9.82895 14.3158V18.3158H13.8289V14.3158H9.82895ZM9.82895 5H13.8289V1H9.82895V5ZM8.25 5V1H4.25V5H8.25ZM8.25 11.1579H4.25V15.1579H8.25V11.1579ZM9.82895 11.1579V15.1579H13.8289V11.1579H9.82895ZM9.82895 8.73684H8.25V16.7368H9.82895V8.73684ZM4.25 12.7368V14.3158H12.25V12.7368H4.25ZM8.25 18.3158H9.82895V10.3158H8.25V18.3158ZM13.8289 14.3158V12.7368H5.82895V14.3158H13.8289ZM9.82895 1H8.25V9H9.82895V1ZM4.25 5V11.1579H12.25V5H4.25ZM8.25 15.1579H9.82895V7.1579H8.25V15.1579ZM13.8289 11.1579V5H5.82895V11.1579H13.8289Z"
      fill="white"
      mask="url(#path-2-inside-1_26269_46919)"
    />
  </svg>,
  "Alert"
);
